DialogInformesAddCtrl.$inject = ['$log', '$scope', '$http'];
export default function DialogInformesAddCtrl($log, $scope, $http) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };

    var urlBase = Sigo.url + '/api/v1/informes';

    vm.formDeshabilitado = true;
    vm.modoEdicion = false;
    vm.reparadores = null;

    vm.submitInforme = function (informe, modoEdicion) {
        return (modoEdicion) ? editarInforme(informe) : anyadirInforme(informe);
    };

    vm.cancelar = function () {
        vm.dialogHandler.cancel();
    }

    cargarDatos();

    function cargarDatos() {
        if (vm.model.informeId) {
            vm.modoEdicion = true;
        }

        var url = urlBase + '/' + vm.model.informeId;
        $http.get(url).then(function (respuesta) {
            vm.informe = respuesta.data;
            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
    }

    function anyadirInforme(informe) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;

        var promesa = $http.post(urlBase, informe);
        promesa.then(function (data) {
            vm.informe = {};
            vm.dialogHandler.close(data);
        }, function (err) {
            $log.error('Error');
        });
    }

    function editarInforme(informe) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;

        var url = urlBase + '/' + informe.id;
        var promesa = $http.put(url, informe);
        promesa.then(function (data) {
            vm.informe = {};
            vm.dialogHandler.close(data);
        }, function (err) {
            $log.error('Error');
        });
    }
}